// extracted by mini-css-extract-plugin
module.exports = {"galleryBlock":"styles_galleryBlock__31teI","editMode":"styles_editMode__2vGVG","galleryContent":"styles_galleryContent__3j4Iv","imageName":"styles_imageName__27AzV"};